document.getElementById('menu-button').onclick = function()
{
    document.getElementById('hidden-menu').style.display = 'block'
}

document.getElementById('close-menu').onclick = function()
{
    document.getElementById('hidden-menu').style.display = 'none'
}

$(window).scroll(function() 
{
    var scrollTop = $(this).scrollTop();
  
    $('#menu-bg').css(
    {
      opacity: function() 
      {
        var elementHeight = $(this).height();
        return 1 - (elementHeight - scrollTop) / elementHeight;
      },
    });
});

$( document ).ready(function() 
{
  var scrollTop = $(this).scrollTop();
  
    $('#menu-bg').css(
    {
      opacity: function() 
      {
        var elementHeight = $(this).height();
        return 1 - (elementHeight - scrollTop) / elementHeight;
      },
    });
});


// WEBPACK FOOTER //
// ./scripts/custom/menu.js